import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody } from "reactstrap";
import { SignOut, Trash } from "@phosphor-icons/react";

const InactiveModal = ({ show, onDeleteClick, onCloseClick, nome }) => {
	return (
		<Modal size="sm" isOpen={show} toggle={onCloseClick} centered={true}>
			<div className="modal-content">
				<ModalBody className="px-4 py-5 text-center">
					<p className="text-muted font-size-16 mb-4">
						Tem certeza de que deseja inativar?
					</p>
					<p className="text-muted font-size-16 mb-4 fw-bold">
						{nome}
					</p>

					<div className="hstack gap-2 justify-content-center mb-0">
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={onDeleteClick}
						>
							Confirmar
						</Button>
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={onCloseClick}
						>
							<SignOut size={16} /> Fechar
						</Button>
					</div>
				</ModalBody>
			</div>
		</Modal>
	);
};

InactiveModal.propTypes = {
	onCloseClick: PropTypes.func,
	onDeleteClick: PropTypes.func,
	show: PropTypes.bool,
	nome: PropTypes.any,
};

export default InactiveModal;
